import React from "react";
import { Modal, Button, Table } from "react-bootstrap";
import Swal from "sweetalert2";

const PoLogsModal = ({ show, handleClose, item, test, handleAssign }) => {


  const user = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const userEmail = user?.data?.user?.email || "";

  if (!item) return null;

  return (
    <Modal show={show} onHide={handleClose} size="lg" enforceFocus={false}>
      <Modal.Header closeButton>
        <Modal.Title>PO Logs - {item?.poNumber || "N/A"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="container-fluid">

          {/* PO Details */}
          <h5 className="mb-3">PO Details</h5>
          <Table bordered hover size="sm">
            <tbody>
              <tr>
                <th>PO Number</th>
                <td>{item.poNumber || "N/A"}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td>{item.status || "N/A"}</td>
              </tr>
              <tr>
                <th>GST</th>
                <td>
                  ₹
                  {(
                    Number(item?.totalCGSTAmount || 0) +
                    Number(item?.totalSGSTAmount || 0) +
                    Number(item?.totalIGSTAmount || 0)
                  ).toFixed(2)}
                </td>
              </tr>
              <tr>
                <th>Total Amount</th>
                <td>₹{item?.totalAmount?.toFixed(2) || "0.00"}</td>
              </tr>
              <tr>
                <th>Created By</th>
                <td>{item.createdBy?.name || "N/A"}</td>
              </tr>
              <tr>
                <th>Created At</th>
                <td>{item?.createdAt ? new Date(item.createdAt).toLocaleString() : "N/A"}</td>
              </tr>
            </tbody>
          </Table>

          {/* Items Table */}
          <h6>Items</h6>
          <Table striped bordered hover responsive size="sm">
            <thead>
              <tr>
                <th>#</th>
                <th>Part No</th>
                <th>Description</th>
                <th>Qty</th>
                <th>Rate</th>
                <th>Amount</th>
                <th>Supplier</th>
              </tr>
            </thead>

            <tbody>
              {item?.items?.map((it, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>

                  {/* FIXED: Correct Repair PO item structure */}
                  <td>{it?.partNo || "N/A"}</td>

                  <td>{it?.description || "N/A"}</td>

                  <td>{it?.approveQty || 0}</td>

                  <td>{it?.rate || 0}</td>

                  <td>{(Number(it?.approveQty || 0) * Number(it?.rate || 0)).toFixed(2)}</td>

                  {/* Supplier for Repair PO is taken from parent, not item */}
                  <td>{item?.supplier?.name || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* History Table */}
          {item?.history?.length > 0 && (
            <>
              <h6 className="mt-4">History</h6>
              <Table bordered hover responsive size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th colSpan="2">Status From-TO</th>
                    <th>Remark</th>
                    <th>Updated By</th>
                    <th>Role</th>
                    <th>Date</th>
                  </tr>
                </thead>

                <tbody>
                  {item.history
                    .slice()
                    .sort(
                      (a, b) =>
                        new Date(b.date || b.updatedAt) - new Date(a.date || a.updatedAt)
                    )
                    .map((h, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>{h?.fromStatus || "N/A"}</td>
                        <td>{h?.toStatus || "N/A"}</td>

                        <td>
                          {Array.isArray(h?.remark)
                            ? h.remark.map((r, i) => <div key={i}>{r}</div>)
                            : h?.remark || "N/A"}
                        </td>

                        <td>{h?.user?.name || "N/A"}</td>

                        <td>
                          {h?.role === "pomaker"
                            ? "PO Maker"
                            : h?.role === "pochecker"
                            ? "PO Checker"
                            : h?.role === "superAdmin"
                            ? "Super Admin"
                            : h?.role || "N/A"}
                        </td>

                        <td>
                          {h?.date || h?.updatedAt
                            ? new Date(h.date || h.updatedAt).toLocaleString()
                            : "N/A"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center">
        {[
          "ravidagdi@gmail.com",
          "dd@indigoinfraprojects.com",
          "ajitindigo@gmail.com"
        ]
          .map((email) => email.toLowerCase())
          .includes(userEmail?.toLowerCase()) && (
          <>
            <Button
              variant="success"
              className="me-2"
              onClick={async () => {
                try {
                  await handleAssign(item?._id, "Approved");
                  handleClose();
                } catch (error) {
                  Swal.fire("Error", "Failed to approve PO. Please try again.", "error");
                }
              }}
            >
              <i className="fa fa-check me-1"></i> Approve
            </Button>

            <Button
              variant="warning"
              className="me-2"
              onClick={async () => {
                try {
                  await handleAssign(item?._id, "Send-Back");
                  handleClose();
                } catch (error) {
                  Swal.fire("Error", "Failed to send back PO. Please try again.", "error");
                }
              }}
            >
              <i className="fa fa-reply me-1"></i> Send to Maker
            </Button>
          </>
        )}

        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PoLogsModal;
